<template>
  <v-container grid-list-lg v-if="false">
    <v-card style="border-radius:12px">
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">Nossos contatos</h3>
          <!-- <div>sub_description</div> -->
        </div>
      </v-card-title>
      <v-card-text>
        <v-row class="px-3 mb-2">
          <v-icon class="mr-2">mdi-email</v-icon>
          <a href="mailto:contato@fusiontecnologia.com" class="secondary--text">contato@fusiontecnologia.com</a>
        </v-row>
        <v-row class="px-3 my-2">
          <v-icon class="mr-2">mdi-web</v-icon>
          <a href="https://fusiontecnologia.com" target="_blank" class="secondary--text">www.fusiontecnologia.com</a>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end" v-if="false">
        <v-btn flat text color="error">Cancelar</v-btn>
        <v-btn flat text color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-container >
</template>
<script>
export default {
  methods: {
    goToWebsite() {
      window.open('https://checkbits.com.br/suporte/','_blank')
      this.$router.push('/')
    },
  },
  mounted() {
    this.goToWebsite();
  },
}
</script>